import Route from '@ember/routing/route';
import type TASProgramInstanceModel from 'tio-data/models/tas-program-instance';

export default class AuthenticatedTasProgramsShowHistoryRoute extends Route {
  async model() {
    // @ts-expect-error seems like a bug or is the model a template?
    const { programInstance } = this.modelFor(
      'authenticated.tas.programs'
    ) as TASProgramInstanceModel;

    await programInstance.loadHistory();

    return programInstance;
  }
}
